import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../components/AppShell';
import { Field } from '../components/ui';
import { useAuth } from '../store/auth';
import { useAction } from '../lib/hooks';

export default function Login() {
  const login = useAuth((s) => s.login);
  const { busy, error, run } = useAction();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <AuthLayout title="Sign in">
      <form
        className="stack-4"
        style={{ display: 'flex', flexDirection: 'column' }}
        onSubmit={(e) => {
          e.preventDefault();
          run(() => login(email, password));
        }}
      >
        {error ? (
          <div className="notice notice-danger" role="alert">
            {error}
          </div>
        ) : null}

        <Field label="Email">
          <input
            className="input"
            type="email"
            autoComplete="username"
            inputMode="email"
            autoCapitalize="off"
            autoCorrect="off"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>

        <Field label="Password">
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <p className="small muted" style={{ textAlign: 'center' }}>
        No account yet? <Link to="/register" style={{ color: 'var(--brand)', fontWeight: 600 }}>Set up your workshop</Link>
      </p>
    </AuthLayout>
  );
}
